export const messages = {
  "app.menu.cep_records.label": "Person Records",
  "app.menu.cep_records.description": "CEP identity records",

  "app.menu.voter_applications.label": "Voter Applications",
  "app.menu.voter_applications.description": "Voter registration applications",

  "app.menu.voters.label": "Voter Records",
  "app.menu.voters.description": "Registered voters",

  "app.menu.user_account_requests.label": "User Account Requests",
  "app.menu.user_account_requests.description": "User account access requests",
"app.menu.field_operators.label": "Field Operators",
"app.menu.field_operators.description": "Field operator accounts and access requests",
"app.menu.user_accounts.label": "Accounts",
"app.menu.user_accounts.description": "Field operator user accounts",

  "app.menu.electoral_geography.label": "Electoral Geography",
  "app.menu.electoral_geography.description": "Voting centers and electoral geography",

  "app.menu.actions.list": "List",
  "app.menu.actions.new": "New",

  "table.search": "Search",
  "table.noData": "No records found",
  "table.rowsPerPage": "Rows per page",
  "table.of": "of",

  "Picture": "Picture",
  "Identifier": "Identifier",
  "First name": "First name",
  "Last name": "Last name",
  "Date of birth": "Date of birth",
  "Sex": "Sex",
  "Primary contact": "Primary contact",
  "Primary address": "Primary address",
  "Photo": "Photo",
  "Actions": "Actions",
  "View": "View",
  "Photo available": "Photo available",
  "Users": "Users",
  "menu.backoffice": "Backoffice",

    "app.menu.reporting.label": "Reporting",
    "app.menu.reporting.description": "Registration statistics and geographic analysis",
    "app.menu.reporting.overview": "Overview",
    "app.menu.reporting.advanced": "Advanced analysis",
    "Operator reports": "Operators",

    "menu.voter.registration": "Voter Registration",
"menu.voter.applications": "Applications",
"menu.voter.records": "Records",

"Diagnostics": "Diagnosis",
"menu.api_users": "API Users",

"app.menu.reporting.votingCenterReports": "Voting centers",

    "app.menu.actions.manage": "Manage",
    "common.account": "account",
    "common.accountLower": "account",
    "common.accountsLower": "accounts",
    "common.actions": "Actions",
    "common.active": "Active",
    "common.add": "Add",
    "common.address": "Address",
    "common.all": "All",
    "common.allSources": "All sources",
    "common.allStatuses": "All statuses",
    "common.appVersion": "App version",
    "common.application": "Application",
    "common.approved": "Approved",
    "common.archived": "Archived",
    "common.area": "Area",
    "common.cancel": "Cancel",
    "common.captured": "Captured",
    "common.class": "Class",
    "common.clearAll": "Clear all",
    "common.closeFilters": "Close filters",
    "common.code": "Code",
    "common.copy": "Copy",
    "common.day": "Day",
    "common.default": "Default",
    "common.deleted": "Deleted",
    "common.description": "Description",
    "common.details": "Details",
    "common.device": "Device",
    "common.deviceId": "Device ID",
    "common.disabled": "Disabled",
    "common.done": "Done",
    "common.edit": "Edit",
    "common.empty": "(empty)",
    "common.error": "Error",
    "common.event": "Event",
    "common.filters": "Filters",
    "common.first": "First",
    "common.format": "Format",
    "common.from": "From",
    "common.generated": "Generated",
    "common.generating": "Generating...",
    "common.geography": "Geography",
    "common.id": "ID",
    "common.identifier": "Identifier",
    "common.interval": "Interval",
    "common.last": "Last",
    "common.level": "Level",
    "common.loading": "Loading...",
    "common.loading.short": "Loading",
    "common.localFile": "Local file",
    "common.message": "Message",
    "common.metric": "Metric",
    "common.month": "Month",
    "common.name": "Name",
    "common.next": "Next",
    "common.no": "No",
    "common.noAddress": "(no address)",
    "common.noReceipt": "(no receipt)",
    "common.noResults": "No results.",
    "common.notVerified": "Not verified",
    "common.nothingSelected": "Nothing selected.",
    "common.objectKey": "Object key",
    "common.other": "Other",
    "common.page": "page",
    "common.parent": "Parent",
    "common.pending": "Pending",
    "common.person": "Person",
    "common.photo": "Photo",
    "common.picture": "Picture",
    "common.prev": "Prev",
    "common.primary": "Primary",
    "common.ready": "Ready",
    "common.rejected": "Rejected",
    "common.remove": "Remove",
    "common.report": "Report",
    "common.reset": "Reset",
    "common.resetFilters": "Reset filters",
    "common.reviewed": "Reviewed",
    "common.save": "Save",
    "common.saving": "Saving...",
    "common.selectItemTree": "Select an item in the tree",
    "common.selectedItem": "Selected item",
    "common.shown": "shown",
    "common.since": "since",
    "common.source": "Source",
    "common.splash": "splash",
    "common.status": "Status",
    "common.submitted": "Submitted",
    "common.summary": "Summary",
    "common.tabletId": "Tablet ID",
    "common.tags": "Tags",
    "common.thread": "Thread",
    "common.time": "Time",
    "common.to": "To",
    "common.total": "Total",
    "common.type": "Type",
    "common.unknown": "Unknown",
    "common.unnamed": "Unnamed",
    "common.updatingCounts": "Updating counts...",
    "common.user": "User",
    "common.verifiedAt": "Verified at",
    "common.version": "Version",
    "common.view": "View",
    "common.viewSection": "View section",
    "common.week": "Week",
    "common.yes": "Yes",
    "diagnostics.back": "Back to diagnostics",
    "diagnostics.copyReport": "Copy report",
    "diagnostics.details": "Diagnostic details",
    "diagnostics.idPrefix": "Diagnostics id",
    "diagnostics.loading": "Loading diagnostic...",
    "diagnostics.missingIdUrl": "Missing diagnostics id in URL.",
    "diagnostics.noId": "No diagnostics id",
    "diagnostics.notFound": "Diagnostic not found.",
    "diagnostics.view": "View diagnostic",
    "filter.androidDiagnostic": "Android diagnostic",
    "filter.applicationFilters": "Voter application filters",
    "filter.deceased": "Deceased",
    "filter.diagnostic": "Diagnostic",
    "filter.diagnosticFilters": "Diagnostic filters",
    "filter.eventType": "Event type",
    "filter.exclude": "Exclude",
    "filter.exclusionHelp": "Hidden by default. Include shows them with the rest. Only isolates them.",
    "filter.exclusions": "Exclusions",
    "filter.fatalCrash": "Fatal crash",
    "filter.female": "Female",
    "filter.gender": "Gender",
    "filter.age": "Age",
    "filter.minimumAge": "Minimum age",
    "filter.maximumAge": "Maximum age",
    "filter.hasTabletId": "Has tablet ID",
    "filter.hide": "Hide",
    "filter.include": "Include",
    "filter.male": "Male",
    "filter.missingTabletId": "Missing tablet ID",
    "filter.nfcInventory": "NFC inventory",
    "filter.noSexValues": "No sex values.",
    "filter.noTagValues": "No tag values.",
    "filter.only": "Only",
    "filter.operatorFilters": "Operator filters",
    "filter.operatorRequestFilters": "Operator request filters",
    "filter.personFilters": "Person filters",
    "filter.refineApplications": "Refine voter applications",
    "filter.refineDiagnostics": "Refine diagnostics",
    "filter.refineOperatorRequests": "Refine operator requests",
    "filter.refineOperators": "Refine operators",
    "filter.refinePeople": "Refine people",
    "filter.refineVoters": "Refine voters",
    "filter.unresponsive": "Unresponsive",
    "filter.voterFilters": "Voter filters",
    "filter.votingCenterHide": "Hide",
    "filter.votingCenterInclude": "Include",
    "filter.votingCenterOnly": "Only",
    "filter.disabledCenters": "Disabled centers",
    "filter.refineVotingCenters": "Refine voting centers",
    "filter.availability": "Availability",
    "filter.disabledCentersHelp": "Disabled centers are hidden by default. Include shows them with active centers. Only isolates them.",
    "filter.votingCenterReportFilters": "Voting center report filters",
    "geo.addArrondissement": "Add arrondissement",
    "geo.addCommune": "Add commune",
    "geo.addConstituency": "Add constituency",
    "geo.addDepartment": "Add department",
    "geo.addSection": "Add section",
    "geo.addVotingCenter": "Add voting center",
    "geo.arrondissement": "Arrondissement",
    "geo.capacity": "Capacity",
    "geo.communalSection": "Communal section",
    "geo.constituency": "Constituency",
    "geo.item": "Item",
    "geo.noVotingCentersSection": "No voting centers in this section.",
    "geo.subtitle": "Manage administrative and constituency-based electoral geography.",
    "geo.supervisorPassword": "Supervisor password",
    "geo.tag": "Tag",
    "geo.tag.supervisorPasswordMismatch": "Supervisor password mismatch",
    "geo.tags.capacity50": "Capacity warning 50%",
    "geo.tags.capacity70": "Capacity warning 70%",
    "geo.tags.full": "Full",
    "geo.title": "Electoral Geography",
    "geo.votingCenterGidRequired": "Voting center gid is required for update.",
    "geo.votingCentersSelectedSection": "Voting centers in selected section",
    "menu.diagnostics.description": "Diagnostic reports from field devices",
    "menu.diagnostics.label": "Diagnostics",
    "menu.reporting.operators": "Operator reports",
    "menu.users.description": "Users and access roles",
    "menu.users.label": "Users",
    "menu.voter.registration.description": "Voter applications and registry records",
    "person.applicationSubmitted": "APPLICATION SUBMITTED",
    "person.applications": "Applications",
    "person.birthDate": "Date of birth",
    "person.commune": "Commune",
    "person.contact": "contact",
    "person.contacts": "Contacts",
    "person.department": "Department",
    "person.firstName": "First name",
    "person.gid": "GID",
    "person.identity": "Identity",
    "person.lastName": "Last name",
    "person.nationalId": "National ID",
    "person.nationalIdentifier": "National identifier",
    "person.noApplications": "No applications.",
    "person.noContacts": "No contacts.",
    "person.noPhotos": "No photos.",
    "person.noResidences": "No residences.",
    "person.noVoters": "No voters.",
    "person.notRegistered": "NOT REGISTERED",
    "person.officeIdentifierNumber": "Office identifier number",
    "person.personGid": "Person GID",
    "person.photoAlt": "Person photo",
    "person.photos": "Photos",
    "person.pictureAlt": "Person picture",
    "person.recordNumber": "Record number",
    "person.registered": "REGISTERED",
    "person.registrationDate": "Registration date",
    "person.registrationStatus": "Registration status",
    "person.residence": "Residence",
    "person.residences": "Residences",
    "person.section": "Section",
    "person.sex": "Sex",
    "person.unnamed": "Unnamed person",
    "person.validFrom": "Valid from",
    "person.validTo": "Valid to",
    "person.viewPerson": "View person",
    "person.voters": "Voters",
    "reporting.accountsAttachedNinu": "Accounts attached to this NINU",
    "reporting.activeCenters": "Active centers",
    "reporting.activeDays": "Active days",
    "reporting.activeOperators": "Active operators",
    "reporting.activitySpan": "Activity span",
    "reporting.advanced": "Advanced",
    "reporting.affectedVoters": "Affected voters",
    "reporting.age18_28": "18 to 28",
    "reporting.age29_38": "29 to 38",
    "reporting.age39_48": "39 to 48",
    "reporting.age49_58": "49 to 58",
    "reporting.age59_68": "59 to 68",
    "reporting.age69plus": "69+",
    "reporting.ageDistribution": "Age distribution",
    "reporting.allArrondissements": "All arrondissements",
    "reporting.allCommunes": "All communes",
    "reporting.allConstituencies": "All constituencies",
    "reporting.allDepartments": "All departments",
    "reporting.allSections": "All sections",
    "reporting.allVotingCenters": "All voting centers",
    "reporting.applicationMix": "Application mix",
    "reporting.applicationQuality": "Application quality",
    "reporting.applicationsLower": "applications",
    "reporting.applicationsToRoll": "From applications to current roll",
    "reporting.applyFilters": "Apply filters",
    "reporting.assigned": "assigned",
    "reporting.assignedElsewhere": "Assigned elsewhere",
    "reporting.busiestDay": "Busiest day",
    "reporting.cadenceHelp": "Every dot is one registration at its actual submission time. Click a dot to open the record.",
    "reporting.capacityUtilization": "Capacity utilization",
    "reporting.capacityUtilizationByDepartment": "Capacity utilization by department",
    "reporting.capacityUtilizationByDepartmentSubtitle": "Applicants as a share of configured registration capacity.",
    "reporting.captureChannel": "Capture channel",
    "reporting.centerLocation": "Center location",
    "reporting.centerNotFound": "Voting center not found.",
    "reporting.centerRegistrationCapacity": "Voting-center registration and capacity",
    "reporting.centersLower": "centers",
    "reporting.centersWithin75Km": "centers within 75 km",
    "reporting.clearHourFilter": "Clear hour filter",
    "reporting.clickCellInspect": "Click a cell to inspect that day",
    "reporting.configured": "configured",
    "reporting.configuredCenters": "Configured centers",
    "reporting.correctionActivity": "Correction activity",
    "reporting.correctionActivityDepartments": "Applicants with correction requests by department.",
    "reporting.correctionDemographics": "Applicant demographics",
    "reporting.correctionDemographicsSubtitle": "Sex and age distribution of applicants with correction requests.",
    "reporting.correctionHighlights": "Correction highlights",
    "reporting.correctionHighlightsSubtitle": "Applicant indicators for correction requests in the selected scope.",
    "reporting.correctionReporting": "Correction reporting",
    "reporting.correctionRequests": "Correction requests",
    "reporting.correctionTimelineSubtitle": "Applicants with correction requests over time.",
    "reporting.corrections": "Corrections",
    "reporting.correctionsByCenter": "Correction requests by voting center",
    "reporting.correctionsByDepartment": "Correction requests by department",
    "reporting.correctionsCenterSubtitle": "Applicants with correction requests by voting center.",
    "reporting.correctionsLower": "corrections",
    "reporting.cumulativeFirstTimeApplicants": "cumulative first-time applicants",
    "reporting.currentElectoralRoll": "Current electoral roll",
    "reporting.currentPollingStations": "Current polling stations",
    "reporting.currentVoters": "Current voters",
    "reporting.dailyForensicView": "Daily forensic view",
    "reporting.dailyInspector": "Daily inspector",
    "reporting.dailyRegistrationActivity": "Daily registration activity",
    "reporting.dateHourMatrix": "Date × hour activity matrix",
    "reporting.distinctApplicants": "Distinct applicants",
    "reporting.distinctVoters": "Distinct voters",
    "reporting.distributionDay": "Distribution through the day",
    "reporting.drillDown": "Drill-down",
    "reporting.duplicateRetransmission": "Duplicate + retransmission",
    "reporting.duplicatesLower": "duplicates",
    "reporting.exactSubmissionCadence": "Exact submission cadence",
    "reporting.firstApplicantsCapacity": "First-time applicants versus capacity",
    "reporting.firstLower": "first",
    "reporting.firstRequest": "First request",
    "reporting.generalFilters": "General filters",
    "reporting.geoCorrections": "Geographic distribution of corrections",
    "reporting.geoDrilldownSubtitle": "Registered voter distribution and drill-down across electoral geography.",
    "reporting.geoRegistrations": "Geographic distribution of registered voters",
    "reporting.geographicScope": "Geographic scope",
    "reporting.gis": "GIS",
    "reporting.gpsCapacityField": "GPS capacity field",
    "reporting.high": "High",
    "reporting.history": "History",
    "reporting.hourFilterHelp": "Applicants by clock hour for this date. Click an hour to filter the applicants below.",
    "reporting.identityLinkage": "Identity linkage",
    "reporting.kmAway": "km away",
    "reporting.lastActivity": "Last activity",
    "reporting.lastLower": "last",
    "reporting.lastApplication": "Last application",
    "reporting.lastRegistration": "Last registration",
    "reporting.lastRequest": "Last request",
    "reporting.lifetimeHistory": "Lifetime history",
    "reporting.loadingCenter": "Loading voting center report…",
    "reporting.loadingDay": "Loading day…",
    "reporting.loadingEllipsis": "Loading…",
    "reporting.loadingOperator": "Loading operator report…",
    "reporting.location": "Location",
    "reporting.locationFootprint": "Location footprint",
    "reporting.locationLower": "location",
    "reporting.low": "Low",
    "reporting.manual": "Manual",
    "reporting.nearbyCapacity": "Nearby capacity",
    "reporting.nearbyCapacityLegend": "Bubble size = center capacity · color = applicant utilization · diamond = selected center",
    "reporting.nextDay": "Next day",
    "reporting.ninuIdentities": "NINU identities",
    "reporting.noActivityVisualize": "No activity to visualize.",
    "reporting.noCenter": "No center",
    "reporting.noData": "No reporting data",
    "reporting.noDataSelectedFilters": "No data for the selected filters.",
    "reporting.noDaySelected": "No day selected.",
    "reporting.noGpsCoordinatesForCenter": "No GPS coordinates are available for this center.",
    "reporting.noOperators": "No operators found",
    "reporting.noRegistrationActivity": "No registration activity.",
    "reporting.noRegistrationHistory": "No registration history.",
    "reporting.noRegistrationsDay": "No registrations on this day.",
    "reporting.noRegistrationsSelection": "No registrations for this selection.",
    "reporting.ofCapacity": "of",
    "reporting.on": "on",
    "reporting.openMap": "Open map",
    "reporting.openRegistration": "Open registration",
    "reporting.operatorActivityReport": "Operator activity report",
    "reporting.operatorComposition": "Operator composition",
    "reporting.operatorNotFound": "Operator not found.",
    "reporting.operatorPerformance": "Operator performance",
    "reporting.operatorPerformanceSubtitle": "Distinct applicants handled by each operator, consolidated across accounts by operator NINU.",
    "reporting.operatorPlaceholder": "Name, NINU, or username",
    "reporting.operatorReport": "View operator report",
    "reporting.operators": "Operators",
    "reporting.operatorsActiveHere": "operators active here",
    "reporting.operatorsLower": "operators",
    "reporting.outcomeComposition": "Outcome composition",
    "reporting.overCapacity": "Over capacity",
    "reporting.overview": "Overview",
    "reporting.peak": "Peak",
    "reporting.perActiveDay": "Per active day",
    "reporting.plannedPollingStations": "Planned polling stations",
    "reporting.previousDay": "Previous day",
    "reporting.refresh": "Refresh",
    "reporting.registeredVoters": "Registered voters",
    "reporting.registeredVotersLower": "registered voters",
    "reporting.registrationActivity": "Registration activity",
    "reporting.registrationCadence": "Registration cadence",
    "reporting.registrationCatchment": "Registration catchment",
    "reporting.registrationCenterSubtitle": "Applicants, configured capacity, and utilization by voting center.",
    "reporting.registrationHighlights": "Registration highlights",
    "reporting.registrationHighlightsSubtitle": "Registration indicators for the selected scope.",
    "reporting.registrationProcess": "Registration process",
    "reporting.registrationStatuses": "Registration statuses",
    "reporting.registrationTimelineSubtitle": "Applicants over time.",
    "reporting.registrationType": "Registration type",
    "reporting.registrations": "Registrations",
    "reporting.registrationsByCenter": "Registrations by voting center",
    "reporting.registrationsByDay": "Registrations by day",
    "reporting.registrationsByDepartment": "Registered voters by department",
    "reporting.registrationsElsewhere": "registrations by accounts assigned elsewhere",
    "reporting.registrationsLower": "registrations",
    "reporting.remaining": "Remaining",
    "reporting.residenceGeography": "Residence geography",
    "reporting.retransmissionsLower": "retransmissions",
    "reporting.scrollZoomHistoryHelp": "Scroll or zoom across the full history. Click any bar to inspect that calendar day.",
    "reporting.selectDay": "Select a day",
    "reporting.selected": "Selected",
    "reporting.selectedCenter": "Selected center",
    "reporting.sexDistribution": "Sex distribution",
    "reporting.sourceMix": "Source mix",
    "reporting.standardActivityDepartments": "Registered voters by department.",
    "reporting.standardLower": "standard",
    "reporting.standardRegistration": "Standard registration reporting",
    "reporting.standardRegistrations": "Standard registrations",
    "reporting.statusProfile": "Status profile",
    "reporting.submittedApplications": "Submitted applications",
    "reporting.temporalFingerprint": "Temporal fingerprint",
    "reporting.totalCapacity": "total capacity",
    "reporting.turnoutTrajectory": "Turnout trajectory",
    "reporting.typeTwoChars": "Type at least two characters",
    "reporting.under18": "Under 18",
    "reporting.uniqueApplicantNinus": "Unique applicant NINUs",
    "reporting.uniqueApplicants": "Unique applicants",
    "reporting.uniqueNinus": "unique NINUs",
    "reporting.unknownCenter": "Unknown center",
    "reporting.unknownError": "Unknown reporting error",
    "reporting.unknownOperator": "Unknown operator",
    "reporting.unknownResidenceSection": "Unknown residence section",
    "reporting.unknownSection": "Unknown section",
    "reporting.unnamedCenter": "Unnamed center",
    "reporting.utilization": "Utilization",
    "reporting.utilized": "utilized",
    "reporting.viewCenterReport": "View voting center report",
    "reporting.views": "Reporting views",
    "reporting.voterDemographics": "Registered voter demographics",
    "reporting.voterDemographicsSubtitle": "Sex and age distribution of registered voters.",
    "reporting.votersLastStation": "Voters in last station",
    "reporting.votersLower": "voters",
    "reporting.votingCenterIntelligence": "Voting center intelligence",
    "reporting.votingCenterReports": "Voting center reports",
    "reporting.votingCenters": "Voting centers",
    "reporting.workforce": "Workforce",
    "user.account": "Account",
    "user.accountRequest": "User account request",
    "user.accounts": "Accounts",
    "user.additionalGranularPermission": "additional granular permission",
    "user.additionalGranularPermissions": "additional granular permissions",
    "user.apiKey": "API key",
    "user.apiKeyCopied": "API key copied.",
    "user.apiKeyCurrentCannotBeViewed": "The current API key cannot be viewed. Generating a new key immediately invalidates the previous key.",
    "user.apiUser": "API user",
    "user.apiUserNotFound": "API user was not found.",
    "user.applicantSubtitle": "Identity and requested account information",
    "user.approvalRequest": "Approval request",
    "user.approvalRequestGid": "Approval request GID",
    "user.approvalRequestSubtitle": "Source request that created this account",
    "user.approve": "Approve",
    "user.assignedRoles": "Assigned roles",
    "user.rolesAndPermissions": "Roles and permissions",
    "user.selectFunctionalAccessGranular": "Select a role for full access, or expand it to choose individual permissions.",
    "user.savePermissions": "Save permissions",
    "user.permissionAssignmentsSaved": "Permissions saved.",
    "user.audit": "Audit",
    "user.backToApiUsers": "Back to API users",
    "user.backToUsers": "Back to users",
    "user.copyApiKeyNow": "Copy this key now. It will not be shown again.",
    "user.createdAccount": "Created account",
    "user.createdAccountSubtitle": "Account created after approval",
    "user.createdAt": "Created at",
    "user.currentAccountStatus": "Current account status",
    "user.decision": "Decision",
    "user.decisionReason": "Decision reason",
    "user.decisionSubtitle": "Review result metadata",
    "user.decisionTime": "Decision time",
    "user.fieldOperatorAccount": "Field operator account",
    "user.generateApiKey": "Generate new API key",
    "user.identitySubtitle": "Operator identity and login name",
    "user.invalidQalaaUserId": "Invalid Qalaa user ID.",
    "user.lifecycleTimestamps": "Lifecycle timestamps",
    "user.newApiKey": "New API key",
    "user.newApiUser": "New API user",
    "user.openPersonRecord": "Open person record",
    "user.openRequest": "Open request",
    "user.profileCouldNotBeLoaded": "The user profile could not be loaded.",
    "user.qalaaId": "Qalaa ID",
    "user.qalaaUser": "Qalaa user",
    "user.reject": "Reject",
    "user.requestGid": "Request GID",
    "user.requestStatus": "Request status",
    "user.roleAssignmentsCouldNotBeSaved": "The role assignments could not be saved.",
    "user.roleAssignmentsSaved": "Role assignments saved.",
    "user.saveRoles": "Save roles",
    "user.selectFunctionalAccess": "Select the functional access required by this user.",
    "user.synchronizationFailed": "Synchronization failed.",
    "user.synchronize": "Synchronize",
    "user.synchronizing": "Synchronizing...",
    "user.tagsSubtitle": "System flags attached to this request",
    "user.unableGenerateApiKey": "Unable to generate API key.",
    "user.unableLoadApiUser": "Unable to load API user.",
    "user.unableSaveApiUser": "Unable to save API user.",
    "user.updatedAt": "Updated at",
    "user.userAccount": "User account",
    "user.userNotFound": "User not found.",
    "user.username": "Username",
    "user.viewAccount": "View account",
    "user.viewApiUser": "View API user",
    "user.viewApprovalRequest": "View approval request",
    "user.viewProfile": "View profile",
    "user.viewVotingCenter": "View voting center",
    "user.votingCenterRequestSubtitle": "Operator assignment requested during sign-up",
    "user.votingCenterSubtitle": "Field operator assignment",
    "user.willBePreserved": "will be preserved.",
    "voter.applicant": "Applicant",
    "voter.applicantNinu": "Applicant NINU",
    "voter.applicantSnapshot": "Applicant snapshot",
    "voter.application": "Voter application",
    "voter.application.subtitle": "Application review record",
    "voter.applicationMetadataSubtitle": "Receipt, source, timeline, and review metadata",
    "voter.applicationPhoto": "Application Photo",
    "voter.attempts": "Attempts",
    "voter.lastAttempt": "Last attempt",
    "voter.primaryApplication": "Primary application",
    "voter.rejectedAt": "Rejected",
    "voter.archivedAt": "Archived",
    "voter.applicationPhotoAlt": "Voter application portrait",
    "voter.applicationType": "Application type",
    "voter.applicationsLinked": "Voter applications linked to this person",
    "voter.assignedVotingLocation": "Assigned voting location",
    "voter.birthDate": "Birth date",
    "voter.checked": "Checked",
    "voter.correction": "Correction",
    "voter.correctionApplication": "Correction application",
    "voter.duplicate": "Duplicate",
    "voter.gpsCoordinates": "GPS coordinates",
    "voter.gpsSubtitle": "Location where the application was submitted",
    "voter.gpsUnavailable": "GPS coordinates unavailable",
    "voter.identitySnapshotSubtitle": "Identity snapshot submitted with this voter application",
    "voter.manualAdjudication": "Manual adjudication",
    "voter.manualEntry": "Manual entry",
    "voter.mrzNfc": "MRZ NFC",
    "voter.mrzSlashNfc": "MRZ / NFC",
    "voter.ninu": "NINU",
    "voter.noPhoto": "No photo",
    "voter.noPortrait": "No portrait",
    "voter.oniPhoto": "ONI photo",
    "voter.oniPhotoAlt": "ONI portrait",
    "voter.oniSearch": "ONI search",
    "voter.operator": "Operator",
    "voter.operatorUserGid": "Operator user GID",
    "voter.personName": "Person name",
    "voter.receipt": "Receipt",
    "voter.receiptNumber": "Receipt number",
    "voter.correctReceiptNumber": "Correct receipt number",
    "voter.newReceiptNumber": "New receipt number",
    "voter.saveCorrection": "Save correction",
    "voter.correctionFailed": "Unable to save correction",
    "voter.correctionJournal": "Correction journal",
    "voter.correctionJournalSubtitle": "Corrections made to this voter application",
    "voter.noCorrections": "No corrections have been made.",
    "voter.journal.receiptNumberCorrected": "Receipt number corrected",
    "voter.oldValue": "Old value",
    "voter.newValue": "New value",
    "voter.correctedBy": "Corrected by",
    "voter.record": "Voter record",
    "voter.record.subtitle": "Registered voter assignment",
    "voter.registeredCitizenIdentity": "Registered citizen identity",
    "voter.requestedVotingLocation": "Requested voting location",
    "voter.retransmission": "Retransmission",
    "voter.reviewedAt": "Reviewed at",
    "voter.reviewer": "Reviewer",
    "voter.reviewerUserGid": "Reviewer user GID",
    "voter.standard": "Standard",
    "voter.statusCode": "Status code",
    "voter.submittedAt": "Submitted at",
    "voter.usersInvolved": "Users involved in submission and review",
    "voter.viewApplication": "View application",
    "voter.viewVoterRecord": "View voter record",
    "voter.voter": "Voter",
    "voter.votingCenter": "Voting center",
    "voter.votingCenterGid": "Voting center GID",
    "voter.votingCenterId": "Voting center ID",
    "en-US": "English",
    "fr-FR": "French",
    "ht-HT": "Haitian",
    "reporting.applicants": "Applicants",
    "reporting.applicantsLower": "applicants",
    "reporting.applicantsByDay": "Applicants by day",
    "reporting.applicantsByCenter": "Applicants by voting center",
    "reporting.applicantCadence": "Applicant cadence",
    "reporting.noApplicantActivity": "No applicant activity.",
    "reporting.noApplicantsDay": "No applicants for this day.",
    "reporting.noApplicantHistory": "No applicant history.",
    "reporting.applicantCapacity": "Applicant capacity",
    "reporting.applicantsElsewhere": "applicants assigned elsewhere",
    "reporting.applicantCatchment": "Applicant catchment",
    "reporting.dailyApplicantActivity": "Daily applicant activity",
    "reporting.noApplicantsSelection": "No applicants for this selection.",
    "reporting.pendingApplications": "Applications being processed",
    "Loading metadata": "Loading metadata",
    "role.systemAdministrator": "System Administrator",
    "role.systemAdministrator.description": "Full access to every secured function.",
    "role.userAdministration": "User Administration",
    "role.userAdministration.description": "Manage users and their permissions.",
    "role.statisticalReports": "Statistical reports",
    "role.statisticalReports.description": "View statistical, demographic and geographic reports.",
    "role.operationalReports": "Operational reports",
    "role.operationalReports.description": "View operator and voting-center operational reports.",
    "role.operatorManagement": "Operator Management",
    "role.operatorManagement.description": "Review field-operator requests and manage operator accounts.",
    "role.voterRegistrationManagement": "Voter Registration Management",
    "role.voterRegistrationManagement.description": "Manage voter records, applications and related identity information.",
    "role.electoralGeographyManagement": "Electoral Geography Management",
    "role.electoralGeographyManagement.description": "Manage electoral geography and voting centers.",
    "role.diagnosticsManagement": "Diagnostics Management",
    "role.diagnosticsManagement.description": "View and manage diagnostic reports from field devices.",
    "reporting.exportExcel": "Export to Excel",
    "reporting.exportingExcel": "Exporting...",
    "reporting.exportFailed": "Unable to export voting center statistics.",
    "voterRoll.preliminaryRolls": "Preliminary voter rolls",
    "voterRoll.preliminaryRolls.description": "Create, review and amend preliminary voter rolls.",
    "voterRoll.finalRolls": "Final voter rolls",
    "voterRoll.finalRolls.description": "Review and print final voter rolls.",
    "voterRoll.preliminary": "Preliminary voter roll",
    "voterRoll.final": "Final voter roll",
    "voterRoll.roll": "Voter roll",
    "voterRoll.event": "Electoral event",
    "voterRoll.eventDate": "Event date",
    "voterRoll.cutoff": "Application cutoff",
    "voterRoll.createdAt": "Created",
    "voterRoll.closedAt": "Closed",
    "voterRoll.entries": "Voters",
    "voterRoll.amendments": "Amendments",
    "voterRoll.sourceRoll": "Source roll",
    "voterRoll.viewRoll": "View roll",
    "voterRoll.notFound": "Voter roll not found.",
    "voterRoll.typeMismatch": "The voter roll type does not match this page.",
    "voterRoll.preview": "Preview voter list",
    "voterRoll.livePreview": "Current voter-list preview",
    "voterRoll.loadingPreview": "Loading voter-list preview...",
    "voterRoll.registeredVoters": "registered voters",
    "voterRoll.pollingStations": "polling stations",
    "voterRoll.pollingStation": "Polling station",
    "voterRoll.votersLower": "voters",
    "voterRoll.printBooklet": "Print booklet",
    "voterRoll.preparingBooklet": "Preparing booklet…",
    "voterRoll.openingPrintDialog": "Opening print dialog…",
    "voterRoll.previewLiveNotice": "This preview reflects the current voter register. It may still change until the preliminary voter roll is created.",
    "voterRoll.agencyName": "Provisional Electoral Council",
    "voterRoll.bookletTitle": "Voter roll",
    "voterRoll.livePreviewType": "CURRENT DATA PREVIEW",
    "voterRoll.number": "No.",
    "voterRoll.photo": "Photo",
    "voterRoll.familyName": "Family name",
    "voterRoll.firstName": "First name",
    "voterRoll.dateOfBirth": "Date of birth",
    "voterRoll.sex": "Sex",
    "voterRoll.status.queued": "Queued",
    "voterRoll.status.generating": "Generating",
    "voterRoll.status.open": "Open",
    "voterRoll.status.closed": "Closed",
    "voterRoll.status.failed": "Failed",
    "voterRoll.status.ready": "Ready",
    "menu.reporting.tablets": "Tablet reports",
    "filter.tabletFilters": "Tablet filters",
    "filter.refineTablets": "Refine tablet fleet",
    "reporting.tablet": "Tablet",
    "reporting.tabletVrApplication": "VR application",
    "reporting.tabletBattery": "Battery",
    "reporting.tabletLastContact": "Last contact",
    "reporting.tabletContactMdm": "MDM",
    "reporting.tabletContactBackend": "VR backend",
    "reporting.tabletRequiredVersion": "Required version",
    "reporting.tabletCurrent": "Current",
    "reporting.tabletOperational": "Operational",
    "reporting.tabletCondition": "Condition",
    "reporting.tabletAssignment": "Assignment",
    "reporting.tabletIncludeUnassigned": "Include tablets not assigned to an operator",
    "reporting.tabletNoOperator": "Not assigned",
    "reporting.tabletStale": "No MDM or VR backend contact for more than 24 hours",
    "reporting.tabletOutdated": "Outdated VR application",
    "reporting.tabletAppMissing": "VR application missing",
    "reporting.tabletStaleShort": "No recent contact",
    "reporting.tabletOutdatedShort": "Outdated application",
    "reporting.tabletAppMissingShort": "Application missing",

    "common.latest": "Latest",
  "common.ok": "OK",
  "geo.unableToDisableVotingCenter": "Unable to disable voting center",
  "geo.votingCenterCannotBeDisabled": "This voting center cannot be disabled because it has associated voters and voter applications.",
  "geo.votingCenterCannotDisableVotersAndApplications": "This voting center cannot be disabled because it has associated voters and voter applications.",
  "geo.votingCenterCannotDisableVoters": "This voting center cannot be disabled because it has associated voters.",
  "geo.votingCenterCannotDisableApplications": "This voting center cannot be disabled because it has associated voter applications.",
  "geo.votingCenterCannotDisableNotEmpty": "This voting center cannot be disabled because it is not empty.",
  "common.enabled": "Enabled",

  // API developer documentation
  "app.menu.developer.label": "Developer",
  "app.menu.developer.apiDocumentation": "API documentation",
  "developer.apiDocs.title": "API documentation",
  "developer.apiDocs.developerDocumentation": "Developer documentation",
  "developer.apiDocs.guide": "Guide",
  "developer.apiDocs.reference": "Reference",
  "developer.apiDocs.searchEndpoints": "Search endpoints",
  "developer.apiDocs.noEndpointsMatch": "No endpoints match the search.",
  "developer.apiDocs.accessDenied": "API documentation access denied",
  "developer.apiDocs.pageRequires": "This page requires",
  "developer.apiDocs.documentationGuide": "Documentation guide",
  "developer.apiDocs.description": "Description",
  "developer.apiDocs.usage": "Usage",
  "developer.apiDocs.request": "Request",
  "developer.apiDocs.pathParameters": "Path parameters",
  "developer.apiDocs.queryParameters": "Query parameters",
  "developer.apiDocs.unresolvedParameters": "Unresolved parameters",
  "developer.apiDocs.body": "Body",
  "developer.apiDocs.mode": "Mode",
  "developer.apiDocs.noRequestBody": "No request body.",
  "developer.apiDocs.response": "Response",
  "developer.apiDocs.notes": "Notes",
  "developer.apiDocs.tryIt": "Try it",
  "developer.apiDocs.name": "Name",
  "developer.apiDocs.type": "Type",
  "developer.apiDocs.values": "Values",
  "developer.apiDocs.default": "Default",
  "developer.apiDocs.item": "item",
  "developer.apiDocs.nullable": "nullable",
  "developer.apiDocs.unique": "unique",
  "developer.apiDocs.predicate": "Predicate",
  "developer.apiDocs.permission": "Permission",
  "developer.apiDocs.requiresPermission": "Requires {permission}",
  "developer.apiDocs.predicateProtected": "Execution is predicate-protected by {predicate}; permission membership alone cannot pre-authorize it.",
  "developer.apiDocs.unspecifiedPolicy": "The endpoint has no explicit execution policy.",
  "developer.apiDocs.headers": "Headers",
  "developer.apiDocs.empty": "(empty)",
  "developer.apiDocs.execute": "Execute",
  "developer.apiDocs.executing": "Executing…",
  "developer.apiDocs.copyCurl": "Copy cURL",
  "developer.apiDocs.sessionNote": "Browser execution uses the current session. Copied cURL does not include browser session credentials.",
  "developer.apiDocs.emptyServiceUri": "getServiceUri() returned an empty service URI",
  "developer.apiDocs.mustBeJsonObject": "{name} must be a JSON object",
  "developer.apiDocs.unboundParameters": "This endpoint contains parameters without an HTTP binding in the generated REST contract.",
  "developer.apiDocs.multipleBodies": "This endpoint declares multiple request bodies and cannot be represented as one raw HTTP request.",
  "developer.apiDocs.methodBodyUnsupported": "{method} with a request body cannot be executed by the browser Fetch API.",
  "developer.apiDocs.pathParameterRequired": "Path parameter {name} is required",
  "developer.apiDocs.unresolvedPathVariable": "Unresolved path variable remains in {path}",
};
